import React, { ElementType } from 'react';
import { TextLink, Typography } from '@guildeducationinc/recess';
import { Link } from 'react-router-dom';
import { trackEvent } from 'src/services/analytics';
import styles from './QuizShelfHeading.module.scss';

export const QuizShelfHeading = () => {
	return (
		<>
			<Typography variant='h3'>Your quiz results are in</Typography>
			<Typography className={styles.subhead} variant='body2'>
				Explore these recommendations based on the goals, experiences, and interests you shared.
				<TextLink
					className={styles.textLink}
					component={Link as unknown as ElementType}
					label='Retake quiz'
					onClick={() =>
						trackEvent('Clickable', {
							tag: 'recommendationsTabStartProgramQuiz',
							text: 'Start Program Quiz',
							type: 'button',
						})
					}
					to='/quiz'
					variant='standalone'
				>
					Retake quiz
				</TextLink>
			</Typography>
		</>
	);
};
